import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeaderPhone from "./components/HeaderPhone";
import Loading from "./components/Loading";
import Lenis from "@studio-freight/lenis";
import { LoadContext } from "./App";

const Layout = ({ children }) => {
  const { setLoad } = useContext(LoadContext);

  const [sidebar, setSidebar] = useState(false);
  const [count, setCount] = useState(0);

  const refImages = useRef();
  const refLoading = useRef();
  const refHeaderPhone = useRef();
  const refSidebarButton = useRef();

  useEffect(() => {
    setLoad(false);
    let countImages = 0;

    const handleShow = () => {
      setCount(100);
      if (refLoading.current) {
        refLoading.current.style.opacity = 0;
        setLoad(true);
        setTimeout(() => {
          if (refLoading.current) {
            refLoading.current.style.display = "none";
          }
        }, 500);
      }
    };

    const handleCharge = (index) => {
      console.log(`Image numéro ${index + 1} : Chargée !!!`);
      countImages++;
      const pourcentage = Math.ceil((countImages / images.length) * 100);
      setCount(pourcentage);
      if (countImages === images.length) {
        console.log("fini");
        handleShow();
      }
    };

    const images = refImages.current.querySelectorAll("img");
    console.log("Recharge Layout");
    console.log("Il y a " + images.length + " image(s) dans cette page");
    if (images.length === 0) {
      handleShow();
    } else {
      images.forEach((image, index) => {
        if (image.complete) {
          handleCharge(index);
        } else {
          console.log(`Image numéro ${index + 1} : En retard !!!`);
          image.addEventListener("load", () => handleCharge(index));
        }
      });
    }
  }, []);

  useEffect(() => {
    const handleDelete = (e) => {
      if (
        refHeaderPhone.current &&
        refSidebarButton.current &&
        !refHeaderPhone.current.contains(e.target) &&
        !refSidebarButton.current.contains(e.target)
      ) {
        setSidebar(false);
      }
    };
    document.addEventListener("click", handleDelete);
    return () => {
      document.removeEventListener("click", handleDelete);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 920) {
        setSidebar(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Intercepter les clics sur les ancres
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const id = target.getAttribute("href");
        const el = document.querySelector(id);
        if (el) {
          lenis.scrollTo(el);
        }
      }
    };

    document.addEventListener("click", handleAnchorClick);

    return () => {
      lenis.destroy();
      document.removeEventListener("click", handleAnchorClick);
    };
  }, []);

  return (
    <div className="containerBody">
      <Loading count={count} refLoading={refLoading} />
      <Header sidebar={sidebar} />
      <div
        className="surface-supp"
        style={
          sidebar
            ? { transform: "translateX(0)" }
            : { transform: "translateX(-100%)" }
        }
        ref={refHeaderPhone}
      >
        <HeaderPhone />
      </div>

      <button className="sidebar" ref={refSidebarButton}>
        <div
          className="close"
          style={sidebar ? { display: "flex" } : { display: "none" }}
          onClick={() => setSidebar(false)}
        ></div>
        <div
          className="open"
          style={!sidebar ? { display: "flex" } : { display: "none" }}
          onClick={() => setSidebar(true)}
        >
          <div></div>
        </div>
      </button>
      <div
        className="containerPage"
        ref={refImages}
        style={sidebar ? { filter: "blur(5px)", pointerEvents: "none" } : {}}
      >
        {children}
      </div>
      <Footer sidebar={sidebar} />
    </div>
  );
};

export default Layout;
